import type React from "react"

export const DepletionRateIcon = (props: React.ComponentProps<"svg">): JSX.Element => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
        >
            <g fill='currentColor'>
                <path
                    fillRule='evenodd'
                    d='M12.619 17.337c-.382.507-1.148.53-1.63.047l-6.207-6.207c-.482-.482-.46-1.248.046-1.63l9.436-7.106c.42-.317 1.035-.257 1.437.145l3.879 3.88c.402.401.461 1.016.145 1.436zm-.946-1.263l1.262-1.676a7.74 7.74 0 01-1.075-.198c-.369-.098-.775-.246-1.115-.484-.734-.511-.862-1.283-.936-1.732l-.002-.009c-.09-.545-.133-.761-.292-.93-.272-.29-.824-.578-1.42-.807a10.033 10.033 0 00-.997-.323l-.013-.004h-.003a.787.787 0 01-.148-.053l-.842.634zM8.336 8.802l4.666-3.514 3.876 3.875-2.896 3.845c-.048 0-.107-.002-.175-.004-.2-.008-.474-.023-.773-.057a6.293 6.293 0 01-.895-.16c-.29-.078-.495-.168-.617-.252-.122-.085-.188-.204-.27-.696l-.016-.104c-.065-.414-.173-1.103-.688-1.652-.544-.579-1.403-.972-2.015-1.208l-.197-.073zm9.399-.776l.606-.805-3.396-3.396-.805.606z'
                    clipRule='evenodd'
                ></path>
                <path d='M9.946 20.665l-.89-2.609A.082.082 0 008.977 18a.08.08 0 00-.077.056l-.852 2.628a1.01 1.01 0 00.46 1.187.994.994 0 001.323-.323l.004-.006a1.008 1.008 0 00.11-.877zm-.527.726c.002-.117.015-.224.02-.331a4.519 4.519 0 00-.001-.631c-.008-.107-.021-.215-.02-.333.071.091.126.194.162.304.035.111.053.227.053.344.005.234-.07.463-.214.647z'></path>
            </g>
        </svg>
    )
}
